<template>
  <div class="columns mt-0" style="align-items: flex-end">
    <form-field-input
      :label="label"
      class="column is-6"
      placeholder="First Name"
      v-model="entity.first_name"
      :validation-errors="validationErrors.first_name"
      :size="size"
    ></form-field-input>

    <form-field-input
      placeholder="Last Name"
      class="column is-6"
      v-model="entity.last_name"
      :validation-errors="validationErrors.last_name"
      :size="size"
    ></form-field-input>
  </div>
</template>

<script>
export default {
  name: "FormFieldFullName",
  props: {
    label: {
      type: String,
      default: 'Name'
    },
    entity: {
      type: Object,
      required: true
    },
    validationErrors: {
      type: Object,
      required: true
    },
    size: {
      type: String,
      default: 'is-small'
    }
  }
}
</script>

<style lang="scss" scoped>
@import "../../styles/variables/variables";

.column {
  margin-bottom: 0;

  @include mobile {
    margin-bottom: 0.75rem;
  }
}
</style>
